import React from "react";
import { Modal, Box, LinearProgress } from "@material-ui/core";

const LoadingModal = ({ loading }) => {
    return (
        <Modal open={loading} aria-labelledby="loading-modal">
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 600,
                    bgcolor: "#c5c5c5",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 10,
                }}
            >
                <LinearProgress sx={{ mt: 4 }} />
            </Box>
        </Modal>
    );
};

export default LoadingModal;
